import React, { useEffect, useState } from "react";
import { assetti, esecuzioni, Esercizio, finalita, modalita, tipologia } from "../interfaces/Esercizio";
import { Sessione } from "../interfaces/Sessione";
import { formatTime } from "../utils/utils";

interface Props {
  //token: string;
  sessione: Sessione;
}

export default function SessioneDetailsTable({ sessione }: Props) {
  return (
    <table className="table table-bordered rounded">
      <tbody>
        <tr>
          <th>Ultimo aggiornamento</th>
          <td>{sessione.updated_at
            ? new Intl.DateTimeFormat("it-IT", {
                day: "2-digit",
                month: "2-digit",
                year: "numeric",
                hour: "2-digit",
                minute: "2-digit",
                second: "2-digit"
              }).format(new Date(sessione.updated_at))
            : '--'}
        </td>
        </tr>
        <tr>
          <th>Nome</th>
          <td>{sessione.name || "-"}</td>
        </tr>
        <tr>
          <th>Descrizione</th>
          <td>{sessione.description || "-"}</td>
        </tr>
        <tr>
          <th>Fraquenza di utilizzo</th>
          <td>{sessione.repetitions}</td>
        </tr>
        <tr>
          <th>Esercizi contenuti</th>
          <td>{sessione.activities.length}</td>
        </tr>
        <tr>
          <th>Tempo attivo</th>
          <td>{formatTime(sessione.active_time * sessione.activities.length * sessione.repetitions || 0)}</td>
        </tr>
        <tr>
          <th>Tempo di recupero</th>
          <td>{formatTime(sessione.recovery_time * sessione.activities.length * sessione.repetitions || 0)}</td>
        </tr>
        <tr>
          <th>Tempo totale</th>
          <td>{formatTime((sessione.active_time + sessione.recovery_time) * sessione.activities.length * sessione.repetitions || 0)}</td>
        </tr>
        <tr>
          <th>Complessità gestione gravitaria</th>
          <td><div className="time-badge">{sessione.gravity_management_complexity || 0}</div></td>
        </tr>
        <tr>
          <th>complessità coordinazione motoria</th>
          <td><div className="time-badge">{sessione.motor_coordination_complexity || 0}</div></td>
        </tr>
        <tr>
          <th>Intensità cardio-respiratoria</th>
          <td><div className="time-badge">{sessione.cardiorespiratory_complexity || 0}</div></td>
        </tr>
        <tr>
          <th>Attrezzi</th>
          <td>{sessione.equipment}</td>
        </tr>
        <tr>
          <th>Contiena esercizi raccomandati per</th>
          <td>{sessione.recommended_for}</td>
        </tr>
        <tr>
          <th>Contiene esercizi controindicati per</th>
          <td>{sessione.contraindicated_for}</td>
        </tr>
      </tbody>
    </table >
  );
}
